import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { installStaleAppRecovery } from "./lib/staleAppRecovery";
import App from "./App.tsx";
import "./index.css";

// Remove any old offline cache and recover once from missing files after a publish
installStaleAppRecovery();

// Initialize Sentry BEFORE rendering the app
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
